// @ts-nocheck
(function () {
  "use strict";
  const ITEMS_PER_PAGE = 10;

  // Prevent re-execution if script is loaded multiple times
  if (window.FindAnEventInitialized) return;
  window.FindAnEventInitialized = true;

  // ============================================================================
  // Shared Utility Functions
  // ============================================================================

  function escapeHtml(text) {
    if (!text) return "";
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  function getDefaultAvatar(name) {
    // Generate a simple SVG avatar with the first letter of the name and first letter of the last name
    const initial = name
      ? escapeHtml(
          name
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase())
            .join("")
        )
      : "?";
    const svg = `<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" fill="#e5e7eb"/>
      <text x="50" y="50" font-family="Arial, sans-serif" font-size="40" fill="#6b7280" text-anchor="middle" dominant-baseline="central" font-weight="bold">${initial}</text>
    </svg>`;
    // Encode SVG for data URI
    return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  }

  function formatDate(dateString) {
    if (!dateString) return "";
    try {
      return new Date(dateString).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    } catch {
      return dateString;
    }
  }

  // Format start date/time with timezone: "June 30, 5:30PM"
  // If endDateString is provided, applies end date display rules:
  // - Same day as start → start datetime only
  // - Different day → start datetime + end date only (no time)
  function formatDate(dateString, city, stateProvince, country, endDateString) {
    if (!dateString) return "";
    try {
      const localDate = window.FindEventHelpers?.convertUTCToMarketTimezone?.(
        dateString,
        country
      );

      if (!localDate) {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        return dateString;
      }

      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      let hours = localDate.hours;
      const minutes = localDate.minutes;
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      if (hours === 0) hours = 12;
      const timeStr = `${hours}:${minutes.toString().padStart(2, "0")}${ampm}`;
      const startDateTime = `${monthNames[localDate.month]} ${localDate.day}, ${timeStr}`;

      if (endDateString) {
        const endLocal = window.FindEventHelpers?.convertUTCToMarketTimezone?.(endDateString, country);
        const isSameDay = endLocal
          ? localDate.year === endLocal.year && localDate.month === endLocal.month && localDate.day === endLocal.day
          : dateString?.substring(0, 10) === endDateString?.substring(0, 10);
        if (!isSameDay) {
          const endDateOnly = endLocal
            ? `${monthNames[endLocal.month]} ${endLocal.day}`
            : endDateString.substring(0, 10);
          return `${startDateTime} - ${endDateOnly}`;
        }
      }

      return startDateTime;
    } catch {
      return dateString;
    }
  }

  function getMarket() {
    // For logged in users: use market tag from customer tags
    if (
      typeof window !== "undefined" &&
      window.customer &&
      window.customer.tags &&
      Array.isArray(window.customer.tags)
    ) {
      for (const tag of window.customer.tags) {
        const trimmedTag = tag.trim();
        if (trimmedTag.startsWith("market:")) {
          return trimmedTag; // Return full tag string like "market:US"
        }
      }
    }

    // For logged off users: use selected market from Shopify localization
    if (typeof window !== "undefined" && window.shopifyLocalization) {
      const country = window.shopifyLocalization.country;
      if (country && typeof country === "string") {
        return country.toUpperCase();
      }
    }

    // Fallback to data-market attribute or Shopify locale
    const findEventComponent = document.querySelector("find-an-event");
    if (findEventComponent?.getAttribute("data-market")) {
      return findEventComponent.getAttribute("data-market");
    }

    // Try Shopify locale as last resort
    if (typeof window !== "undefined" && window.Shopify?.locale) {
      const locale = window.Shopify.locale;
      const parts = locale.split("-");
      if (parts.length > 1) {
        return parts[parts.length - 1];
      }
    }

    // Default fallback
    return "US";
  }

  function getSearchRadius() {
    return window.FindEventHelpers?.getSelectedSearchRadius?.() || 100;
  }

  function getSelectedEventTypes() {
    return window.FindEventHelpers?.getSelectedEventTypes?.() || [];
  }

  // Helper function to get all checked event format inputs (checkboxes only)
  // Returns unique values - checks if ANY checkbox with that value is checked
  function getCheckedEventFormats() {
    const checked = [];
    // Check if any checkbox with value "in_person" is checked (mobile or desktop)
    const inPerson = document.querySelector(
      'input[name="event-format"][value="in_person"]:checked'
    );
    const virtual = document.querySelector(
      'input[name="event-format"][value="virtual"]:checked'
    );
    const hybrid = document.querySelector(
      'input[name="event-format"][value="hybrid"]:checked'
    );

    if (inPerson) checked.push("in_person");
    if (virtual) checked.push("virtual");
    if (hybrid) checked.push("hybrid");
    return checked;
  }

  // Helper function to sync filter checkboxes
  // Syncs both mobile and desktop checkboxes with the same value
  function syncFilterCheckboxes(formats) {
    // Ensure at least one format is checked
    if (formats.length === 0) {
      formats = ["in_person"];
    }

    // Uncheck all first (both mobile and desktop)
    document.querySelectorAll('input[name="event-format"]').forEach((input) => {
      input.checked = false;
    });

    // Check the specified formats in BOTH mobile and desktop
    formats.forEach((format) => {
      const selector = `input[name="event-format"][value="${format}"]`;
      const inputs = document.querySelectorAll(selector);
      // Check all checkboxes with this value (mobile and desktop)
      inputs.forEach((input) => {
        input.checked = true;
        // Trigger change event to update filters
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  // Helper function to check if toggle link should be visible
  function shouldShowToggleLink() {
    const checked = getCheckedEventFormats();
    const hasInPerson = checked.includes("in_person");
    const hasVirtual = checked.includes("virtual");

    // Hide if all three are checked
    if (checked.length === 3) {
      return false;
    }

    // Hide if both in-person and virtual are checked
    if (hasInPerson && hasVirtual) {
      return false;
    }

    return true;
  }

  // Helper function to update toggle link visibility and text
  function updateToggleLinkVisibility() {
    const toggleLink = document.querySelector(".find-an-event-links a");
    if (toggleLink) {
      const shouldShow = shouldShowToggleLink();
      toggleLink.style.display = shouldShow ? "" : "none";

      // Update text based on checkbox selection
      if (shouldShow) {
        const checkedFormats = getCheckedEventFormats();
        const hasInPerson = checkedFormats.includes("in_person");
        const hasVirtual = checkedFormats.includes("virtual");

        // If in-person is NOT selected, show "Show in-person events"
        if (!hasInPerson) {
          toggleLink.textContent = "Show in-person events";
        }
        // If in-person IS selected and Virtual is NOT selected, show "Show virtual events"
        else if (hasInPerson && !hasVirtual) {
          toggleLink.textContent = "Show virtual events";
        }
        // Otherwise, determine based on current state (if both are selected, show opposite)
        else {
          // If both in-person and virtual are selected, show the opposite of what's currently shown
          // Default to "Show virtual events" if text doesn't match expected patterns
          const currentText = toggleLink.textContent.toLowerCase();
          if (currentText.includes("in-person")) {
            toggleLink.textContent = "Show virtual events";
          } else {
            toggleLink.textContent = "Show in-person events";
          }
        }
      }
    }
  }

  function getSelectedDateRange() {
    // Try to use FindEventHelpers first
    if (window.FindEventHelpers?.getSelectedDateRange) {
      const result = window.FindEventHelpers.getSelectedDateRange();

      if (result && (result.dateFrom || result.dateTo)) {
        return result;
      }
    }

    // Fallback: read directly from DOM
    // Check desktop sidebar first (always visible if not mobile)
    const desktopSidebar = document.querySelector(".event-filter-sidebar");
    let dateFromInput = null;
    let dateToInput = null;

    if (
      desktopSidebar &&
      window.getComputedStyle(desktopSidebar).display !== "none"
    ) {
      dateFromInput = desktopSidebar.querySelector('input[name="date-from"]');
      dateToInput = desktopSidebar.querySelector('input[name="date-to"]');
    }

    // If not found in desktop, check mobile drawer (only if open)
    if ((!dateFromInput || !dateToInput) && typeof document !== "undefined") {
      const mobileDrawerDetails = document.querySelector(
        "#Details-mobile-filter-drawer-container"
      );
      if (mobileDrawerDetails && mobileDrawerDetails.hasAttribute("open")) {
        if (!dateFromInput) {
          dateFromInput = mobileDrawerDetails.querySelector(
            'input[name="date-from"]'
          );
        }
        if (!dateToInput) {
          dateToInput = mobileDrawerDetails.querySelector(
            'input[name="date-to"]'
          );
        }
      }
    }

    // Final fallback: query all inputs (will get the first visible one)
    if (!dateFromInput) {
      dateFromInput = document.querySelector('input[name="date-from"]');
    }
    if (!dateToInput) {
      dateToInput = document.querySelector('input[name="date-to"]');
    }

    return {
      dateFrom: dateFromInput?.value || "",
      dateTo: dateToInput?.value || "",
    };
  }

  function getSelectedAttendeeType() {
    return window.FindEventHelpers?.getSelectedAttendeeType?.() || "all";
  }

  function getEventCardsGrid(eventCardsResults) {
    return eventCardsResults?.querySelector(".event-cards-grid");
  }

  function getLoadMoreButton() {
    return document.querySelector("#event-load-more-btn");
  }

  function createEventCard(event, onJoinEvent) {
    const card = document.createElement("div");
    card.className = "event-card-item";

    const datetimeDisplay = formatDate(event.start_date, event.city, event.state_province, event.country, event.end_date);

    const distance = event.distance
      ? `${event.distance.toFixed(1)} miles away`
      : "";
    const eventType = event.event_type || "Event";
    const eventFormat =
      event.event_format === "virtual"
        ? "VIRTUAL"
        : event.event_format === "hybrid"
        ? "HYBRID"
        : "IN-PERSON";

    const headerColors = ["yellow", "blue", "green", "pink", "purple"];
    const headerColorClass = `event-card-header--${
      headerColors[(event.id || 0) % headerColors.length]
    }`;
    const hostName =
      event.first_name || event.last_name
        ? `${event.first_name || ""} ${event.last_name || ""}`.trim()
        : "";

    card.innerHTML = `
    <div class="event-card-header ${headerColorClass}">
      <div class="event-card-type">${eventFormat}</div>
      <div class="event-card-title h6">${escapeHtml(eventType)}</div>
      ${distance ? `<div class="event-card-distance">${distance}</div>` : ""}
    </div>
    <div class="event-card-body">
      ${
        event.city
          ? `<div class="event-card-location">${escapeHtml(event.city)}${
              event.state_province
                ? `, ${escapeHtml(event.state_province)}`
                : ""
            }</div>`
          : ""
      }
      <div class="event-card-datetime">${datetimeDisplay}</div>
      ${
        hostName
          ? `
        <div class="flex flex-row event-card-host">
          <div class="event-card-host-info">
            <div class="event-card-host-avatar">
              <img src="${escapeHtml(
                event.advisor_avatar || getDefaultAvatar(hostName)
              )}" alt="${escapeHtml(hostName)}" class="host-avatar" />
            </div>
            <div class="flex flex-col gap-1">
              <div class="event-card-host-label">HOST:</div>
              <div class="event-card-host-name">${escapeHtml(hostName)}</div>
            </div>
          </div>
        </div>
      `
          : ""
      }
      <button class="event-card-button event_rsvp_form_trigger">JOIN EVENT</button>
    </div>
  `;

    // Attach the function to the button
    const joinButton = card.querySelector(".event-card-button");
    if (joinButton && onJoinEvent && typeof onJoinEvent === "function") {
      joinButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        onJoinEvent(event);
      });
    }

    return card;
  }

  function showError(message, eventCardsResults) {
    const errorContainer = document.querySelector(".event-cards-error-message");
    const sideFilter = document.querySelector(".event-filter-sidebar");

    // Hide load more button on error
    const loadMoreBtn = getLoadMoreButton();
    if (loadMoreBtn) {
      loadMoreBtn.style.display = "none";
    }

    if (eventCardsResults) {
      eventCardsResults.classList.add("hidden");
    }

    errorContainer.classList.remove("hidden");
    errorContainer.innerHTML = `<p class="text-red-500 text-center">${escapeHtml(
      message
    )}</p>`;
  }

  function showNoResults(zipCode, eventCardsResults) {
    const eventCardsGrid = getEventCardsGrid(eventCardsResults);
    const errorContainer = document.querySelector(".event-cards-error-message");

    const noResults = document.createElement("div");
    noResults.className =
      "event-card-no-results col-span-4 text-center w-full flex flex-col gap-2 items-center";

    if (zipCode) {
      noResults.innerHTML = `
      <p class="text-red-500">No events found near ZIP/Postal code ${zipCode}.</p>
      <p>Try expanding your search radius or check back later for new events.</p>
    `;
    } else {
      noResults.innerHTML = `
      <p>No virtual events found.</p>
    `;
    }
    errorContainer.classList.remove("hidden");
    errorContainer.innerHTML = noResults.innerHTML;
  }

  function updatePaginationInfo(pagination) {
    const filterHeader = document.querySelector(
      ".event-filter-header p.event-filter-title"
    );
    if (filterHeader) {
      const total = pagination.total || 0;
      filterHeader.textContent = `${total} Event${total !== 1 ? "s" : ""}`;
    }
  }

  function updateLoadMoreButton(pagination, loadMoreBtn, onLoadMore) {
    if (!loadMoreBtn) return;
    loadMoreBtn.style.display = pagination.hasNextPage ? "block" : "none";
    // Don't set onclick here - let initializeLoadMore handle event listeners
  }

  function renderEvents(events, pagination, zipCode, eventCardsResults, state) {
    const eventCardsGrid = getEventCardsGrid(eventCardsResults);
    if (!eventCardsGrid) {
      console.error("Event cards grid not found");
      return;
    }

    eventCardsGrid
      .querySelectorAll(
        ".event-card-item:not(.event-card-template), .event-card-error, .event-card-no-results"
      )
      .forEach((el) => el.remove());

    if (events.length === 0) {
      showNoResults(zipCode, eventCardsResults);
      return;
    }

    events.forEach((event) =>
      eventCardsGrid.appendChild(createEventCard(event, state?.onJoinEvent))
    );

    updatePaginationInfo(pagination);
    updateLoadMoreButton(pagination, getLoadMoreButton(), state?.onLoadMore);

    // Update toggle link visibility after rendering events
    updateToggleLinkVisibility();

    // Equalize event card body heights
    if (typeof window.equalizeEventCardBodyHeights === 'function') {
      setTimeout(() => {
        window.equalizeEventCardBodyHeights();
      }, 100);
      // Also equalize after images load
      setTimeout(() => {
        window.equalizeEventCardBodyHeights();
      }, 500);
    }

    if (state) {
      state.currentPage = pagination.page || 1;
      state.totalPages = pagination.totalPages || 1;
      state.hasNextPage = pagination.hasNextPage || false;
      state.currentZipCode = zipCode || null;
    }
  }

  function appendEvents(events, eventCardsResults, onJoinEvent) {
    const eventCardsGrid = getEventCardsGrid(eventCardsResults);
    if (!eventCardsGrid) return;
    events.forEach((event) =>
      eventCardsGrid.appendChild(createEventCard(event, onJoinEvent))
    );
    
    // Equalize event card body heights after appending new events
    if (typeof window.equalizeEventCardBodyHeights === 'function') {
      setTimeout(() => {
        window.equalizeEventCardBodyHeights();
      }, 100);
      // Also equalize after images load
      setTimeout(() => {
        window.equalizeEventCardBodyHeights();
      }, 500);
    }
  }

  function animateCards(eventCardsGrid) {
    const hiddenCards = eventCardsGrid.querySelectorAll(
      ".event-card-item:nth-child(n+7)"
    );
    hiddenCards.forEach((card, index) => {
      card.style.opacity = "0";
      card.style.transform = "translateY(20px)";
      card.style.transition = "opacity 0.3s ease, transform 0.3s ease";
      setTimeout(() => {
        card.style.opacity = "1";
        card.style.transform = "translateY(0)";
      }, index * 100);
    });
  }

  function showLoadMoreError(message, loadMoreBtn) {
    const existingError = document.querySelector(".load-more-error-message");
    if (existingError) existingError.remove();

    if (!loadMoreBtn) return;

    const errorEl = document.createElement("p");
    errorEl.className = "load-more-error-message text-red-500 text-center mb-2";
    errorEl.textContent = message;
    loadMoreBtn.parentNode.insertBefore(errorEl, loadMoreBtn);
  }

  function clearLoadMoreError() {
    const existingError = document.querySelector(".load-more-error-message");
    if (existingError) existingError.remove();
  }

  // Flag to prevent multiple simultaneous load more calls
  let isLoadingMore = false;

  async function loadMoreEvents(
    currentZipCode,
    currentPage,
    market,
    searchRadius,
    eventCardsResults,
    loadMoreBtn,
    state
  ) {
    if (isLoadingMore) return;

    // Check if we're viewing virtual-only events (no in_person format checked)
    const eventFormats = getCheckedEventFormats();
    const isVirtualOnly = !eventFormats.includes("in_person");

    // Allow load more without zip code for virtual-only events
    if (!isVirtualOnly && !currentZipCode) return;
    if (!state?.hasNextPage) return;

    isLoadingMore = true;
    clearLoadMoreError();
    const nextPage = (currentPage || 1) + 1;
    const originalButtonText = loadMoreBtn?.textContent || "Load More Events";

    if (loadMoreBtn) {
      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = "Loading...";
    }

    try {
      const params = {
        market,
        page: nextPage,
        items_per_page: ITEMS_PER_PAGE,
      };
      // Only add zip and search_radius if zip code is provided
      if (currentZipCode) {
        params.zip = currentZipCode;
        if (searchRadius) params.search_radius = searchRadius;
      }

      // Add filter parameters (same as initial search)
      const eventTypes = getSelectedEventTypes();
      if (eventTypes.length > 0) {
        params.event_types = eventTypes;
      }

      // If no formats are checked, default to in_person
      if (eventFormats.length > 0) {
        params.event_formats = eventFormats;
      } else {
        params.event_formats = ["in_person"];
      }

      const dateRange = getSelectedDateRange();
      // Always send date_from - use selected value or default to today
      params.date_from = dateRange.dateFrom || getTodayDateString();
      if (dateRange.dateTo) {
        params.date_to = dateRange.dateTo;
      }

      const attendeeType = getSelectedAttendeeType();
      // Only add attendee_type if a specific type is selected (not "all")
      if (attendeeType && attendeeType !== "all") {
        params.attendee_type = attendeeType;
      }

      const result = await getEventsByZipCode(
        params,
        loadMoreBtn || document.createElement("button")
      );

      if (result.error) {
        // Extract error message from error object
        const errorMessage =
          typeof result.error === "string"
            ? result.error
            : result.error?.message || "Failed to load more events";
        showLoadMoreError(`Failed to load more events: ${errorMessage}`, loadMoreBtn);
        return;
      }

      if (!result.data) {
        showLoadMoreError("Failed to load more events", loadMoreBtn);
        return;
      }

      appendEvents(result.data, eventCardsResults, state?.onJoinEvent);

      const pagination = result.meta?.pagination || {};
      if (state) {
        state.currentPage = pagination.page || nextPage;
        state.hasNextPage = pagination.hasNextPage || false;
      }

      updateLoadMoreButton(pagination, loadMoreBtn, state?.onLoadMore);
    } catch (error) {
      // Extract error message from error object
      const errorMessage =
        error?.message || error?.error?.message || "Please try again.";
      showLoadMoreError(`Failed to load more events: ${errorMessage}`, loadMoreBtn);
    } finally {
      isLoadingMore = false;
      if (loadMoreBtn) {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = originalButtonText;
      }
    }
  }

  function createState(onLoadMore, onJoinEvent) {
    return {
      currentPage: 1,
      totalPages: 1,
      hasNextPage: false,
      currentZipCode: null,
      onLoadMore,
      onJoinEvent,
    };
  }

  function addSmoothAnimations(eventCardsResults) {
    if (eventCardsResults) {
      eventCardsResults.style.opacity = "0";
      eventCardsResults.style.transform = "translateY(20px)";
      eventCardsResults.style.transition =
        "opacity 0.5s ease, transform 0.5s ease";
    }
  }

  function showResultsWithAnimation(eventCardsResults, onShow) {
    if (eventCardsResults) {
      eventCardsResults.style.opacity = "1";
      eventCardsResults.style.transform = "translateY(0)";
    }
    if (onShow) onShow();
  }

  // Store the current load more handler to allow removal
  let currentLoadMoreHandler = null;

  function initializeLoadMore(eventCardsResults, onLoadMore) {
    const loadMoreBtn = getLoadMoreButton();
    const eventCardsGrid = getEventCardsGrid(eventCardsResults);

    if (loadMoreBtn && eventCardsGrid) {
      if (window.innerWidth <= 768)
        eventCardsGrid.classList.add("mobile-limit");
      // Remove old onclick handler
      loadMoreBtn.onclick = null;
      // Remove old event listener if it exists
      if (currentLoadMoreHandler) {
        loadMoreBtn.removeEventListener("click", currentLoadMoreHandler);
      }
      // Store the new handler and add it
      currentLoadMoreHandler = onLoadMore;
      loadMoreBtn.addEventListener("click", onLoadMore);
    }
  }

  function toggleMobileFilter(show) {
    const toggle = document.querySelector(".mobile-filter-toggle-container");
    if (toggle) toggle.style.display = show ? "flex" : "none";
  }

  function showLoadMoreButton() {
    const btn = getLoadMoreButton();
    if (btn) btn.classList.remove("hidden");
  }

  function hideLoadMoreButton() {
    const btn = getLoadMoreButton();
    if (btn) {
      btn.style.display = "none";
      btn.classList.add("hidden");
    }
  }

  // Debounce function to limit filter change requests
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Get today's date in YYYY-MM-DD format for date inputs
  function getTodayDateString() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // Initialize date inputs with min attribute set to today and default value
  function initializeDateInputs() {
    const today = getTodayDateString();
    const dateFromInputs = document.querySelectorAll('input[name="date-from"]');
    const dateToInputs = document.querySelectorAll('input[name="date-to"]');

    dateFromInputs.forEach((input) => {
      input.setAttribute("min", today);
      input.value = today;
    });

    dateToInputs.forEach((input) => {
      input.setAttribute("min", today);
    });
  }

  // Store active search handlers for filter changes
  let activeFilterChangeHandler = null;
  let activeLoadMoreHandler = null;

  // Function to get all zip code inputs on the page
  function getAllZipCodeInputs() {
    return document.querySelectorAll(".find-an-event-input");
  }

  // Function to sync all zip code inputs when one changes
  function syncZipCodeInputs(changedInput) {
    const allInputs = getAllZipCodeInputs();
    const value = changedInput.value;
    allInputs.forEach((input) => {
      if (input !== changedInput) {
        input.value = value;
      }
    });
  }

  // Initialize zip code input synchronization
  function initializeZipCodeSync() {
    const allInputs = getAllZipCodeInputs();
    allInputs.forEach((input) => {
      // Add sync listener
      input.addEventListener("input", (e) => {
        syncZipCodeInputs(e.target);
      });

      // Also sync on blur to catch paste events
      input.addEventListener("blur", (e) => {
        syncZipCodeInputs(e.target);
      });
    });
  }

  // Shared handleSubmit function that both forms use
  async function sharedHandleSubmit(
    e,
    zipCodeInput,
    submitButton,
    eventCardsResults,
    errorMessageContainer,
    state,
    onLoadMore
  ) {
    e.preventDefault();
    e.stopPropagation();

    // Sync zip code to all inputs before processing
    if (zipCodeInput) {
      syncZipCodeInputs(zipCodeInput);
    }

    // Get zip code from any input (they should all be synced now)
    const allZipInputs = getAllZipCodeInputs();
    let zipCode = null;
    for (const input of allZipInputs) {
      const value = input?.value?.trim();
      if (value) {
        zipCode = value;
        break;
      }
    }
    // Fallback to the passed zipCodeInput if no value found
    if (!zipCode) {
      zipCode = zipCodeInput?.value?.trim();
    }

    if (!zipCode) {
      alert("Please enter a valid ZIP/Postal code");
      return;
    }

    // Find the main event cards results section (shared across all forms)
    const mainEventCardsResults =
      document.querySelector(".event-cards-results") || eventCardsResults;

    // Always show results section (will display error or events)
    if (mainEventCardsResults) {
      mainEventCardsResults.style.display = "flex";
      mainEventCardsResults.classList.remove("hidden");
    }

    const result = await searchEvents(
      zipCode,
      submitButton,
      mainEventCardsResults,
      errorMessageContainer,
      state
    );

    initializeFilterChangeListeners(
      zipCodeInput,
      submitButton,
      mainEventCardsResults,
      errorMessageContainer,
      state,
      onLoadMore
    );

    if (mainEventCardsResults) {
      showResultsWithAnimation(mainEventCardsResults, () => {
        if (result?.success) {
          toggleMobileFilter(true);
          showLoadMoreButton();
          if (onLoadMore) {
            initializeLoadMore(mainEventCardsResults, onLoadMore);
          }
        }
      });

      if (mainEventCardsResults.classList.contains("hidden")) {
        errorMessageContainer.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        // Scroll to results section
        mainEventCardsResults.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }

  function initializeFilterChangeListeners(
    zipCodeInput,
    submitButton,
    eventCardsResults,
    errorMessageContainer,
    state,
    onLoadMore
  ) {
    // Remove previous listeners if they exist
    if (activeFilterChangeHandler) {
      const filterInputs = document.querySelectorAll(
        'input[name="event-type"], input[name="search-radius"], input[name="event-format"], input[name="date-from"], input[name="date-to"], input[name="attendees"]'
      );
      filterInputs.forEach((input) => {
        input.removeEventListener("change", activeFilterChangeHandler);
      });
    }

    // Store the load more handler
    activeLoadMoreHandler = onLoadMore;

    // Create new handler that triggers search when filters change
    activeFilterChangeHandler = debounce(async () => {
      // Update toggle link visibility when filters change
      updateToggleLinkVisibility();

      // Get zip code from any input (they should all be synced)
      const allZipInputs = getAllZipCodeInputs();
      let zipCode = null;
      for (const input of allZipInputs) {
        const value = input?.value?.trim();
        if (value) {
          zipCode = value;
          break;
        }
      }
      // Fallback to the passed zipCodeInput if no value found
      if (!zipCode) {
        zipCode = zipCodeInput?.value?.trim();
      }

      // Check if we're viewing virtual-only events (no in_person format checked)
      const eventFormats = getCheckedEventFormats();
      const isVirtualOnly = !eventFormats.includes("in_person");

      // Allow search without zip code for virtual-only events
      // For in-person events, require a zip code
      if (!isVirtualOnly && (!zipCode || !state?.currentZipCode)) {
        return; // Don't search if no zip code has been entered yet for in-person events
      }

      // Search if: virtual-only OR zip code matches the current search
      if (isVirtualOnly || zipCode === state.currentZipCode) {
        // Show results section
        if (eventCardsResults) {
          eventCardsResults.style.display = "flex";
        }

        // Perform search with updated filters
        const result = await searchEvents(
          zipCode,
          submitButton,
          eventCardsResults,
          errorMessageContainer,
          state
        );

        if (eventCardsResults && result?.success) {
          showResultsWithAnimation(eventCardsResults, () => {
            showLoadMoreButton();
            toggleMobileFilter(true);
            if (activeLoadMoreHandler) {
              initializeLoadMore(eventCardsResults, activeLoadMoreHandler);
            }
          });
        }
      }
    }, 500); // 500ms debounce

    // Add listeners to all filter inputs
    const filterInputs = document.querySelectorAll(
      'input[name="event-type"], input[name="search-radius"], input[name="event-format"], input[name="date-from"], input[name="date-to"], input[name="attendees"]'
    );
    filterInputs.forEach((input) => {
      input.addEventListener("change", activeFilterChangeHandler);
    });
  }

  async function searchEvents(
    zipCode,
    submitButton,
    eventCardsResults,
    errorMessageContainer,
    state
  ) {
    errorMessageContainer.classList.add("hidden");
    const params = {
      market: getMarket(),
      page: 1,
      items_per_page: ITEMS_PER_PAGE,
    };

    // Only add zip and search_radius if zip code is provided
    if (zipCode) {
      params.zip = zipCode;
      params.search_radius = getSearchRadius();
    }

    // Add filter parameters
    const eventTypes = getSelectedEventTypes();
    if (eventTypes.length > 0) {
      params.event_types = eventTypes;
    }

    const eventFormats = getCheckedEventFormats();
    // If no formats are checked, default to in_person
    if (eventFormats.length > 0) {
      params.event_formats = eventFormats;
    } else {
      params.event_formats = ["in_person"];
    }

    const dateRange = getSelectedDateRange();
    // Always send date_from - use selected value or default to today
    params.date_from = dateRange.dateFrom || getTodayDateString();
    if (dateRange.dateTo) {
      params.date_to = dateRange.dateTo;
    }

    const attendeeType = getSelectedAttendeeType();
    // Only add attendee_type if a specific type is selected (not "all")
    if (attendeeType && attendeeType !== "all") {
      params.attendee_type = attendeeType;
    }
    state.currentZipCode = zipCode;
    try {
      const result = await getEventsByZipCode(params, submitButton);

      // Check if response contains an error field
      if (result.error) {
        // Extract error message from error object
        const errorMessage =
          typeof result.error === "string"
            ? result.error
            : result.error?.message ||
              "Failed to search events. Please try again.";
        showError(errorMessage, eventCardsResults);
        return {
          success: false,
          error: errorMessage,
        };
      }

      if (!result.data) {
        const errorMessage = "Failed to search events. Please try again.";
        showError(errorMessage, eventCardsResults);
        return {
          success: false,
          error: errorMessage,
        };
      }

      renderEvents(
        result.data,
        result.meta?.pagination || {},
        zipCode,
        eventCardsResults,
        state
      );
      return { success: true };
    } catch (error) {
      // Extract error message from error object
      const errorMessage = "Please enter a valid search location.";
      showError(errorMessage, eventCardsResults);
      return { success: false, error: errorMessage };
    }
  }

  // ============================================================================
  // API Functions
  // ============================================================================

  async function getEventsByZipCode(params, submitButton) {
    if (!window.PublicEventsService)
      throw new Error("PublicEventsService not found");

    // Store original button state only if button exists
    let originalButtonText = "FIND AN EVENT";
    let buttonSelector = null;

    if (submitButton) {
      // Capture original text before changing it
      const currentText = (submitButton.textContent || "").trim();
      // If button is already in "SEARCHING..." state, use default text
      originalButtonText =
        currentText === "SEARCHING..." || !currentText
          ? "FIND AN EVENT"
          : currentText;

      // Store a way to find the button again if reference is lost
      if (submitButton.closest) {
        const form = submitButton.closest(".find-an-event-form");
        if (form) {
          buttonSelector = () => form.querySelector(".find-an-event-button");
        }
      }

      submitButton.textContent = "SEARCHING...";
      submitButton.disabled = true;
    }

    try {
      return await window.PublicEventsService.searchByZip(params);
    } catch (error) {
      // Re-throw error so it can be handled by caller
      throw error;
    } finally {
      // Always restore button state, even if error occurred
      let buttonToRestore = submitButton;

      // If button reference is lost, try to find it again
      if (!buttonToRestore && buttonSelector) {
        buttonToRestore = buttonSelector();
      }

      // Ensure we have a valid button and original text
      if (
        buttonToRestore &&
        originalButtonText &&
        originalButtonText !== "SEARCHING..."
      ) {
        buttonToRestore.textContent = originalButtonText;
        buttonToRestore.disabled = false;
      } else if (buttonToRestore) {
        // Fallback: always restore to "FIND AN EVENT" if something went wrong
        buttonToRestore.textContent = "FIND AN EVENT";
        buttonToRestore.disabled = false;
      }
    }
  }

  function handleJoinEvent(event) {
    const eventTime = new Date(event.start_date).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Prepare event data for the React RSVP modal
    const selectedEventData = {
      event_date: formatDate(event.start_date, event.city, event.state_province, event.country, event.end_date),
      event_time: eventTime,
      location: `${event.city}, ${event.state_province}`,
      event_type: event.event_type || "",
      event_id: event.id || "",
      advisor_first_name: event.first_name || "",
      advisor_last_name: event.last_name || "",
      advisor_email: event.email || "",
    };

    // Open the React RSVP modal
    if (typeof window.openEventRsvpModal === "function") {
      window.openEventRsvpModal(selectedEventData);
    } else {
      console.error(
        "Event RSVP modal not initialized. Make sure the event-rsvp.js script is loaded."
      );
    }
  }

  // ============================================================================
  // Classes
  // ============================================================================

  class FindAnEventComponent extends HTMLElement {
    constructor() {
      super();
      this.findEventForm = this.querySelector(".find-an-event-form");
      this.eventCardsResults = this.querySelector(".event-cards-results");
      this.zipCodeInput = this.querySelector(".find-an-event-input");
      // Look for toggle link within the form first, then within the component
      this.virtualEventsLink =
        this.findEventForm?.querySelector(".find-an-event-toggle-link") ||
        this.querySelector(".find-an-event-toggle-link");
      this.submitButton = this.findEventForm?.querySelector(
        ".find-an-event-button"
      );
      this.errorMessageContainer = this.querySelector(
        ".event-cards-error-message"
      );
      this.state = createState(
        () => this.handleLoadMore(),
        (event) => handleJoinEvent(event)
      );
      this.initialize();
    }

    initialize() {
      if (this.eventCardsResults) this.eventCardsResults.style.display = "none";
      toggleMobileFilter(false);

      // Set initial in_person filter state (default checked)
      const inPersonFilter = document.querySelector(
        'input[name="event-format"][value="in_person"], input[name="event-format"][value="in-person"]'
      );
      if (
        inPersonFilter &&
        !document.querySelector('input[name="event-format"]:checked')
      ) {
        inPersonFilter.checked = true;
      }

      // Add validation to prevent all checkboxes from being unchecked
      // Also sync checkboxes with the same value (mobile/desktop)
      const formatCheckboxes = document.querySelectorAll(
        'input[name="event-format"]'
      );
      formatCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", (e) => {
          const value = e.target.value;
          const isChecked = e.target.checked;

          // Sync all checkboxes with the same value (mobile and desktop)
          const sameValueCheckboxes = document.querySelectorAll(
            `input[name="event-format"][value="${value}"]`
          );
          sameValueCheckboxes.forEach((cb) => {
            if (cb !== e.target) {
              cb.checked = isChecked;
            }
          });

          // If unchecking this checkbox, check if it's the last one
          if (!isChecked) {
            const checkedFormats = getCheckedEventFormats();
            // If no formats are checked, prevent unchecking
            if (checkedFormats.length === 0) {
              e.preventDefault();
              e.target.checked = true;
              // Re-sync since we prevented the uncheck
              sameValueCheckboxes.forEach((cb) => {
                cb.checked = true;
              });
            }
          }

          // If checking in_person without a zip code, show error and scroll to input
          if (isChecked && value === "in_person") {
            const allZipInputs = getAllZipCodeInputs();
            let hasZipCode = false;
            for (const input of allZipInputs) {
              if (input.value?.trim()) {
                hasZipCode = true;
                break;
              }
            }

            if (!hasZipCode) {
              const allErrorMsgs =
                document.querySelectorAll("#zip-error-message");

              allZipInputs.forEach((input) => {
                input.classList.add(
                  "!border-red-500",
                  "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
                );
                // Remove error state when user starts typing
                input.addEventListener(
                  "input",
                  function onInput() {
                    allZipInputs.forEach((inp) => {
                      inp.classList.remove(
                        "!border-red-500",
                        "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
                      );
                    });
                    allErrorMsgs.forEach((msg) => {
                      msg.classList.add("hidden");
                    });
                    input.removeEventListener("input", onInput);
                  },
                  { once: true }
                );
              });

              allErrorMsgs.forEach((errorMsg) => {
                errorMsg.classList.remove("hidden");
              });

              // Scroll to and focus the first zip code input
              if (allZipInputs.length > 0) {
                allZipInputs[0].scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
                allZipInputs[0].focus();
              }
            }
          }

          // If unchecking in_person, clear any zip code input errors
          if (!isChecked && value === "in_person") {
            const allZipInputs = getAllZipCodeInputs();
            const allErrorMsgs =
              document.querySelectorAll("#zip-error-message");
            allZipInputs.forEach((input) => {
              input.classList.remove(
                "!border-red-500",
                "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
              );
            });
            allErrorMsgs.forEach((msg) => {
              msg.classList.add("hidden");
            });
          }

          // Update toggle link text when checkboxes change
          updateToggleLinkVisibility();
        });
      });

      if (this.findEventForm) {
        this.findEventForm.addEventListener(
          "submit",
          this.handleSubmit.bind(this)
        );
      }
      if (this.virtualEventsLink) {
        this.virtualEventsLink.addEventListener(
          "click",
          this.handleVirtualEvents.bind(this)
        );
      }
      addSmoothAnimations(this.eventCardsResults);
      // Initialize filter change listeners
      initializeFilterChangeListeners(
        this.zipCodeInput,
        this.submitButton,
        this.eventCardsResults,
        this.errorMessageContainer,
        this.state,
        () => this.handleLoadMore()
      );

      // Update toggle link visibility on initialization
      updateToggleLinkVisibility();
    }

    async handleSubmit(e) {
      // Use shared handleSubmit function
      await sharedHandleSubmit(
        e,
        this.zipCodeInput,
        this.submitButton,
        this.eventCardsResults,
        this.errorMessageContainer,
        this.state,
        () => this.handleLoadMore()
      );
    }

    async handleLoadMore() {
      const loadMoreBtn = getLoadMoreButton();
      const eventCardsGrid = getEventCardsGrid(this.eventCardsResults);

      if (eventCardsGrid) {
        eventCardsGrid.classList.remove("mobile-limit");
      }

      await loadMoreEvents(
        this.state.currentZipCode,
        this.state.currentPage,
        getMarket(),
        getSearchRadius(),
        this.eventCardsResults,
        loadMoreBtn,
        this.state
      );

      if (eventCardsGrid) animateCards(eventCardsGrid);
    }

    async handleVirtualEvents(e) {
      e.preventDefault();
      const isShowingVirtual = e.target.textContent
        .toLowerCase()
        .includes("virtual");

      // Get all zip inputs early for use throughout the method
      const allZipInputs = getAllZipCodeInputs();
      const allErrorMsgs = document.querySelectorAll("#zip-error-message");

      // Get zip code from any synced input
      let zipCode = null;
      for (const input of allZipInputs) {
        const value = input?.value?.trim();
        if (value) {
          zipCode = value;
          break;
        }
      }
      // Fallback to local input
      if (!zipCode) {
        zipCode = this.zipCodeInput?.value?.trim();
      }

      // If trying to show in-person events without a zip code, highlight the input with an error and early return
      if (!isShowingVirtual && !zipCode) {
        allZipInputs.forEach((input) => {
          input.classList.add(
            "!border-red-500",
            "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
          );
          // Remove error state when user starts typing
          input.addEventListener(
            "input",
            function onInput() {
              // Remove error styles from all inputs
              allZipInputs.forEach((inp) => {
                inp.classList.remove(
                  "!border-red-500",
                  "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
                );
              });
              // Hide all error messages
              allErrorMsgs.forEach((msg) => {
                msg.classList.add("hidden");
              });
              input.removeEventListener("input", onInput);
            },
            { once: true }
          );
        });

        // Show all error messages
        allErrorMsgs.forEach((errorMsg) => {
          errorMsg.classList.remove("hidden");
        });

        return;
      }

      if (isShowingVirtual) {
        // Show virtual AND hybrid events: uncheck In-Person, check Virtual and Hybrid
        syncFilterCheckboxes(["virtual", "hybrid"]);
        e.target.textContent = "Show in-person events";

        // Clear any zip code input errors when showing virtual events
        allZipInputs.forEach((input) => {
          input.classList.remove(
            "!border-red-500",
            "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
          );
        });
        allErrorMsgs.forEach((msg) => {
          msg.classList.add("hidden");
        });
      } else {
        // Show in-person AND hybrid events: uncheck Virtual, check In-Person and Hybrid
        syncFilterCheckboxes(["in_person", "hybrid"]);
        e.target.textContent = "Show virtual events";
      }

      // Sync all toggle links text
      document
        .querySelectorAll(".find-an-event-toggle-link")
        .forEach((link) => {
          if (link !== e.target) {
            link.textContent = e.target.textContent;
          }
        });

      // Update toggle link visibility
      updateToggleLinkVisibility();

      // Show results section and search
      if (this.eventCardsResults) {
        this.eventCardsResults.style.display = "flex";
      }

      const result = await searchEvents(
        zipCode,
        this.submitButton,
        this.eventCardsResults,
        this.errorMessageContainer,
        this.state
      );

      if (this.eventCardsResults) {
        showResultsWithAnimation(this.eventCardsResults, () => {
          if (result?.success) {
            toggleMobileFilter(true);
            showLoadMoreButton();
            if (this.handleLoadMore) {
              initializeLoadMore(this.eventCardsResults, () =>
                this.handleLoadMore()
              );
            }
          }
        });
        if (this.eventCardsResults.classList.contains("hidden")) {
          this.errorMessageContainer.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } else {
          // Scroll to results section
          this.eventCardsResults.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    }
  }

  class FindAnEventFormHandler {
    constructor(formElement) {
      this.form = formElement;
      this.zipCodeInput = this.form.querySelector(".find-an-event-input");
      this.submitButton = this.form.querySelector(".find-an-event-button");
      this.virtualEventsLink = this.form.querySelector(
        ".find-an-event-toggle-link"
      );
      this.eventCardsResults = document.querySelector(".event-cards-results");
      this.errorMessageContainer = document.querySelector(
        ".event-cards-error-message"
      );
      this.state = createState(
        () => this.handleLoadMore(),
        handleJoinEvent // No handleJoinEvent - only FindAnEventComponent renders event cards
      );
      this.initialize();
    }

    initialize() {
      if (this.eventCardsResults) this.eventCardsResults.style.display = "none";
      toggleMobileFilter(false);

      // Set initial in_person filter state (default checked)
      const inPersonFilter = document.querySelector(
        'input[name="event-format"][value="in_person"], input[name="event-format"][value="in-person"]'
      );
      if (
        inPersonFilter &&
        !document.querySelector('input[name="event-format"]:checked')
      ) {
        inPersonFilter.checked = true;
      }

      // Add validation to prevent all checkboxes from being unchecked
      // Also sync checkboxes with the same value (mobile/desktop)
      const formatCheckboxes = document.querySelectorAll(
        'input[name="event-format"]'
      );
      formatCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", (e) => {
          const value = e.target.value;
          const isChecked = e.target.checked;

          // Sync all checkboxes with the same value (mobile and desktop)
          const sameValueCheckboxes = document.querySelectorAll(
            `input[name="event-format"][value="${value}"]`
          );
          sameValueCheckboxes.forEach((cb) => {
            if (cb !== e.target) {
              cb.checked = isChecked;
            }
          });

          // If unchecking this checkbox, check if it's the last one
          if (!isChecked) {
            const checkedFormats = getCheckedEventFormats();
            // If no formats are checked, prevent unchecking
            if (checkedFormats.length === 0) {
              e.preventDefault();
              e.target.checked = true;
              // Re-sync since we prevented the uncheck
              sameValueCheckboxes.forEach((cb) => {
                cb.checked = true;
              });
            }
          }

          // If checking in_person without a zip code, show error and scroll to input
          if (isChecked && value === "in_person") {
            const allZipInputs = getAllZipCodeInputs();
            let hasZipCode = false;
            for (const input of allZipInputs) {
              if (input.value?.trim()) {
                hasZipCode = true;
                break;
              }
            }

            if (!hasZipCode) {
              const allErrorMsgs =
                document.querySelectorAll("#zip-error-message");

              allZipInputs.forEach((input) => {
                input.classList.add(
                  "!border-red-500",
                  "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
                );
                // Remove error state when user starts typing
                input.addEventListener(
                  "input",
                  function onInput() {
                    allZipInputs.forEach((inp) => {
                      inp.classList.remove(
                        "!border-red-500",
                        "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
                      );
                    });
                    allErrorMsgs.forEach((msg) => {
                      msg.classList.add("hidden");
                    });
                    input.removeEventListener("input", onInput);
                  },
                  { once: true }
                );
              });

              allErrorMsgs.forEach((errorMsg) => {
                errorMsg.classList.remove("hidden");
              });

              // Scroll to and focus the first zip code input
              if (allZipInputs.length > 0) {
                allZipInputs[0].scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
                allZipInputs[0].focus();
              }
            }
          }

          // If unchecking in_person, clear any zip code input errors
          if (!isChecked && value === "in_person") {
            const allZipInputs = getAllZipCodeInputs();
            const allErrorMsgs =
              document.querySelectorAll("#zip-error-message");
            allZipInputs.forEach((input) => {
              input.classList.remove(
                "!border-red-500",
                "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
              );
            });
            allErrorMsgs.forEach((msg) => {
              msg.classList.add("hidden");
            });
          }

          // Update toggle link text when checkboxes change
          updateToggleLinkVisibility();
        });
      });

      if (this.form) {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
      }
      if (this.virtualEventsLink) {
        this.virtualEventsLink.addEventListener(
          "click",
          this.handleVirtualEvents.bind(this)
        );
      }
      addSmoothAnimations(this.eventCardsResults);
      // Initialize filter change listeners
      initializeFilterChangeListeners(
        this.zipCodeInput,
        this.submitButton,
        this.eventCardsResults,
        this.errorMessageContainer,
        this.state,
        () => this.handleLoadMore()
      );

      // Update toggle link visibility on initialization
      updateToggleLinkVisibility();
    }

    async handleVirtualEvents(e) {
      e.preventDefault();
      const isShowingVirtual = e.target.textContent
        .toLowerCase()
        .includes("virtual");

      // Get all zip inputs early for use throughout the method
      const allZipInputs = getAllZipCodeInputs();
      const allErrorMsgs = document.querySelectorAll("#zip-error-message");

      // Get zip code from any synced input
      let zipCode = null;
      for (const input of allZipInputs) {
        const value = input?.value?.trim();
        if (value) {
          zipCode = value;
          break;
        }
      }
      // Fallback to local input
      if (!zipCode) {
        zipCode = this.zipCodeInput?.value?.trim();
      }

      // If trying to show in-person events without a zip code, highlight the input with an error and early return
      if (!isShowingVirtual && !zipCode) {
        allZipInputs.forEach((input) => {
          input.classList.add(
            "!border-red-500",
            "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
          );
          // Remove error state when user starts typing
          input.addEventListener(
            "input",
            function onInput() {
              // Remove error styles from all inputs
              allZipInputs.forEach((inp) => {
                inp.classList.remove(
                  "!border-red-500",
                  "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
                );
              });
              // Hide all error messages
              allErrorMsgs.forEach((msg) => {
                msg.classList.add("hidden");
              });
              input.removeEventListener("input", onInput);
            },
            { once: true }
          );
        });

        // Show all error messages
        allErrorMsgs.forEach((errorMsg) => {
          errorMsg.classList.remove("hidden");
        });

        return;
      }

      if (isShowingVirtual) {
        // Show virtual AND hybrid events: uncheck In-Person, check Virtual and Hybrid
        syncFilterCheckboxes(["virtual", "hybrid"]);
        e.target.textContent = "Show in-person events";

        // Clear any zip code input errors when showing virtual events
        allZipInputs.forEach((input) => {
          input.classList.remove(
            "!border-red-500",
            "shadow-[0_0_0_2px_rgba(239,68,68,0.25)]"
          );
        });
        allErrorMsgs.forEach((msg) => {
          msg.classList.add("hidden");
        });
      } else {
        // Show in-person AND hybrid events: uncheck Virtual, check In-Person and Hybrid
        syncFilterCheckboxes(["in_person", "hybrid"]);
        e.target.textContent = "Show virtual events";
      }

      // Sync all toggle links text
      document
        .querySelectorAll(".find-an-event-toggle-link")
        .forEach((link) => {
          if (link !== e.target) {
            link.textContent = e.target.textContent;
          }
        });

      // Update toggle link visibility
      updateToggleLinkVisibility();

      // Re-fetch eventCardsResults in case it wasn't available during initialization
      const eventCardsResults =
        this.eventCardsResults ||
        document.querySelector(".event-cards-results");

      // Show results section and search
      if (eventCardsResults) {
        eventCardsResults.style.display = "flex";
      }

      const result = await searchEvents(
        zipCode,
        this.submitButton,
        eventCardsResults,
        this.errorMessageContainer,
        this.state
      );

      if (eventCardsResults) {
        showResultsWithAnimation(eventCardsResults, () => {
          if (result?.success) {
            toggleMobileFilter(true);
            showLoadMoreButton();
            if (this.handleLoadMore) {
              initializeLoadMore(eventCardsResults, () =>
                this.handleLoadMore()
              );
            }
          }
        });
        // Scroll to results section
        eventCardsResults.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }

    async handleSubmit(e) {
      // Use shared handleSubmit function
      await sharedHandleSubmit(
        e,
        this.zipCodeInput,
        this.submitButton,
        this.eventCardsResults,
        this.errorMessageContainer,
        this.state,
        () => this.handleLoadMore()
      );
    }

    async handleLoadMore() {
      const loadMoreBtn = getLoadMoreButton();
      const eventCardsGrid = getEventCardsGrid(this.eventCardsResults);

      if (eventCardsGrid) {
        eventCardsGrid.classList.remove("mobile-limit");
      }

      await loadMoreEvents(
        this.state.currentZipCode,
        this.state.currentPage,
        getMarket(),
        getSearchRadius(),
        this.eventCardsResults,
        loadMoreBtn,
        this.state
      );

      if (eventCardsGrid) animateCards(eventCardsGrid);
    }
  }

  // ============================================================================
  // Initialization
  // ============================================================================

  function initializeMobileFilterDrawer() {
    const toggle = document.querySelector("#mobile-filter-toggle-btn");
    const details = document.querySelector(
      "#Details-mobile-filter-drawer-container"
    );
    const closeBtn = document.querySelector(
      ".mobile-filter-drawer .menu-drawer__close-button"
    );
    const backdrop = document.querySelector(
      ".mobile-filter-drawer .menu-drawer__backdrop"
    );

    const openDrawer = () => {
      details.setAttribute("open", "");
      document.body.classList.add("menu-open");
    };

    const closeDrawer = () => {
      details.removeAttribute("open");
      document.body.classList.remove("menu-open");
    };

    if (toggle && details) {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        details.hasAttribute("open") ? closeDrawer() : openDrawer();
      });
    }

    if (closeBtn)
      closeBtn.addEventListener(
        "click",
        (e) => (e.preventDefault(), closeDrawer())
      );
    if (backdrop)
      backdrop.addEventListener(
        "click",
        (e) => (e.preventDefault(), closeDrawer())
      );
  }

  async function waitForDependencies(maxWait = 5000) {
    const start = Date.now();
    while (Date.now() - start < maxWait) {
      if (window.PublicEventsService && window.FindEventHelpers) {
        return true;
      }
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    console.error(
      "PublicEventsService or FindEventHelpers not loaded after",
      maxWait,
      "ms"
    );
    return false;
  }

  async function initialize() {
    const depsReady = await waitForDependencies();
    if (!depsReady) {
      console.error(
        "Cannot initialize find-an-event: dependencies not available"
      );
      return;
    }

    if (!customElements.get("find-an-event")) {
      customElements.define("find-an-event", FindAnEventComponent);
    }

    // Initialize date inputs with min attribute (block past dates)
    initializeDateInputs();

    // Initialize zip code input synchronization
    initializeZipCodeSync();

    document.querySelectorAll(".find-an-event-form").forEach((form) => {
      // Skip forms that are inside a find-an-event custom element (handled by FindAnEventComponent)
      if (form.closest("find-an-event")) {
        return;
      }
      if (!form.dataset.initialized) {
        form.dataset.initialized = "true";
        new FindAnEventFormHandler(form);
      }
    });
    initializeMobileFilterDrawer();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
